var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.289 3.44a1.5 1.5 0 012.12 2.12l-6.364 6.364 6.365 6.365a1.5 1.5 0 01-2.121 2.12l-6.365-6.364-6.363 6.365a1.5 1.5 0 01-2.008.103l-.114-.103a1.5 1.5 0 010-2.121l6.364-6.365-6.364-6.363a1.5 1.5 0 112.122-2.122l6.363 6.364z","fillRule":"evenodd"}));
}

Close.defaultProps = {"width":"24","height":"24"};

module.exports = Close;

Close.default = Close;
